import { useMutation } from '@common-fe/common-fe';
import { AxiosResponse } from 'axios';
import _ from 'lodash';

import { api } from '@/api';
import { API_URL, IPresignUrlRequestDto, IPresignUrlResponse } from '@/dtos';

interface Payload {
  documentId: string;
  fileName?: string;
  employeeId?: string;
}

const useCreateFileUploadUrlQuery = () => {
  const { mutateAsync, isLoading } = useMutation((payload: Payload) =>
    api.post<IPresignUrlResponse, AxiosResponse<IPresignUrlResponse>, IPresignUrlRequestDto>(
      API_URL.DOCUMENTS_FILES_LINK_BY_DOCUMENT_ID(payload?.documentId),
      {
        name: payload?.fileName || '',
        employee_id: _.toNumber(payload.employeeId),
      }
    )
  );

  return {
    createFileUploadUrl: mutateAsync,
    isLoading,
  };
};

export default useCreateFileUploadUrlQuery;
